import en from './team.en';

const enConfig = { en };

export default enConfig;
